import { createSelector } from 'reselect'
import { NAME } from './constants'

export const getAllTags = createSelector(
  (state) => state[NAME],
  (tags) => tags || {}
)
export const getTags = createSelector(
  [(state) => state[NAME], (_, id) => id],
  ({ tags }, id) => (tags[id] && tags[id].tags ? tags[id].tags : [])
)
export const getTag = createSelector(
  [(state) => state[NAME], (_, id) => id],
  ({ tags }, id) => (tags[id] ? tags[id] : {})
)
